import { AdvisoryMessageBanner } from '../data-models/advisory-message.interface';

export const AdvisoryMessageBannerMockConfig: AdvisoryMessageBanner = {
  advisoryLabel: 'Advisory',
  advisoryMessage:
    'Lorem ipsum dolor sit amet debet dicant munere sit in. Eam no suscipit dissentias.',
  isInterline: false,
  interlineMessage: '',
  interlineFlightNo: ''
};
